import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(_component_q_btn, {
        size: "sm",
        icon: _ctx.orderIcon,
        title: _ctx.orderTitle,
        color: _ctx.isSelected('lastName') ? this.selectedColor : this.nonSelectedColor,
        "text-color": "black",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change('lastName')))
      }, null, 8, ["icon", "title", "color"]),
      _createVNode(_component_q_btn, {
        size: "sm",
        label: "Unreviewed",
        color: _ctx.isSelected('totalUnreviewed') ? this.selectedColor : this.nonSelectedColor,
        "text-color": "black",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change('totalUnreviewed')))
      }, null, 8, ["color"]),
      _createVNode(_component_q_btn, {
        size: "sm",
        label: "Escalated",
        color: _ctx.isSelected('totalEscalated') ? this.selectedColor : this.nonSelectedColor,
        "text-color": "black",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.change('totalEscalated')))
      }, null, 8, ["color"])
    ]),
    _: 1
  }, 16))
}